import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CircleAlert, CircleCheck, Info } from 'lucide-react';
import { TONE, TONE_DOT } from '../../lib/rcu/catalog/feedback';
import type { Tone } from '../../lib/rcu/catalog/feedback';
import { useToastStore } from '../../stores/toastStore';

const toneIcon = (tone: Tone): React.ReactElement => {
  if (tone === TONE.SUCCESS) return <CircleCheck className="h-4 w-4" />;
  if (tone === TONE.ERROR || tone === TONE.WARNING) return <CircleAlert className="h-4 w-4" />;
  return <Info className="h-4 w-4" />;
};

/** Bottom-right stack for command feedback. */
export const ToastStack: React.FC = () => {
  const toasts = useToastStore((state) => state.toasts);
  const dismiss = useToastStore((state) => state.dismiss);

  return (
    <div className="pointer-events-none fixed bottom-6 right-6 z-[60] flex w-[320px] flex-col gap-2">
      <AnimatePresence initial={false}>
        {toasts.map((toast) => (
          <motion.button
            key={toast.id}
            type="button"
            layout
            initial={{ opacity: 0, x: 24 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 24 }}
            transition={{ duration: 0.2 }}
            onClick={() => dismiss(toast.id)}
            className="pointer-events-auto flex items-start gap-3 rounded-2xl bg-[#1A1A1A] px-4 py-3 text-left text-white shadow-[0_12px_24px_rgba(0,0,0,0.25)]"
          >
            <span className={`mt-0.5 h-2.5 w-2.5 shrink-0 rounded-full ${TONE_DOT[toast.tone]}`} />
            <span className="flex-1 text-sm">{toast.message}</span>
            <span className="mt-0.5 shrink-0 text-white/50">{toneIcon(toast.tone)}</span>
          </motion.button>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ToastStack;
